import { __ } from "@wordpress/i18n";
import { useState } from "@wordpress/element";
import { api } from "@/config/api-fetch";
import { toast } from "react-toastify";
import { Section } from "@/components/section";
import { css } from "@/utils/css";
import { Select } from "@/components/select";
import { OPENAI } from "@/utils/constants";

export default function Antimanual() {
    const chatModels = OPENAI.CHAT_MODELS;
    const embeddingModels = OPENAI.EMBEDDING_MODELS;

    const [apiKey, setApiKey] = useState(OPENAI.API_KEY);
    const [selectedModel, setSelectedModel] = useState(OPENAI.MODEL);
    const [selectedEmbeddingModel, setSelectedEmbeddingModel] = useState(OPENAI.EMBEDDING_MODEL);
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSaving(true);

        const config = {
            api_key: apiKey,
            model: selectedModel,
            embedding_model: selectedEmbeddingModel,
        };

        try {
            const response = await api.post("/preferences/openai", config);

            if (response) {
                toast.success(__("Settings saved successfully!", "antimanual"));
            } else {
                toast.error(__("Failed to save settings. Please try again.", "antimanual"));
            }
        } catch (error) {
            toast.error(__("An error occurred while saving settings.", "antimanual"));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Section>
            <div id="antimanual" className="tab-content antimanual-tab-pane">
                <h2>{__("OpenAI API Configuration", "antimanual")}</h2>
                <p className="description">{__("Configure your OpenAI API settings to enable the AI features of Antimanual.", "antimanual")}</p>
                <form onSubmit={handleSubmit}>
                    <table className="form-table">
                        <tbody>
                            <tr>
                                <th scope="row">
                                    <label htmlFor="antimanual_api_key">{__("OpenAI API Key:", "antimanual")}</label>
                                </th>
                                <td>
                                    <input
                                        type="password"
                                        name="antimanual_api_key"
                                        className={css("form-input max-w-md")}
                                        value={apiKey}
                                        onChange={(e) => setApiKey(e.target.value)}
                                        required
                                    />

                                    <p className="description">
                                        {__("Get your API key from", "antimanual")}{" "}
                                        <a href="https://platform.openai.com/account/api-keys" target="_blank" rel="noopener noreferrer">
                                            {__("OpenAI", "antimanual")}
                                        </a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <label htmlFor="antimanual_model">{__("OpenAI Model:", "antimanual")}</label>
                                </th>
                                <td>
                                    <Select
                                        className={css("form-input form-select max-w-md")}
                                        value={selectedModel}
                                        onChange={(e) => setSelectedModel(e)}
                                        options={chatModels}
                                        help={__("Select the OpenAI model to use for generating responses.", "antimanual")}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <label htmlFor="antimanual_embedding_model">{__("OpenAI Embedding Model:", "antimanual")}</label>
                                </th>
                                <td>
                                    <Select
                                        className={css("form-input form-select max-w-md")}
                                        value={selectedEmbeddingModel}
                                        onChange={(e) => setSelectedEmbeddingModel(e)}
                                        options={embeddingModels}
                                        help={__("Select the OpenAI model to use for generating embeddings.", "antimanual")}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="submit">
                        <button type="submit" className={css("btn btn-primary")} disabled={saving}>
                            {saving ? __("Saving...", "antimanual") : __("Save Settings", "antimanual")}
                        </button>
                    </p>
                </form>
            </div>
        </Section>
    );
}
